"use client";
import styles from "./OutletSideDrawer.module.scss";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";
import { SideDrawerListItem } from "../__shared__/SideDrawerListItem/SideDrawerListItem";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

export function OutletSideDrawerUI() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <SideDrawerListItem
        label="Outlet"
        onClick={withSideDrawerAnalytics("Outlet", () => setOpen(true))}
        trailingIcon={<ChevronRight size="medium" />}
      />
      <SEOFriendlyDrawer
        isOpen={open}
        onClose={() => setOpen(false)}
        heading="Outlet"
        primaryButtonText="Close"
      >
        <div className={styles.outlet} data-testid="product:outlet">
          <span className={styles.heading}>
            Good as new returned items with up to 30% off
          </span>
          <p>
            Everything in our Outlet has been thoroughly checked by our expert
            Partners to make sure they meet our quality standards. They can be
            returned within 30 days and have the same guarantees as our new,
            full price items.
          </p>
          <span className={styles.heading}>Certified: Like new</span>
          <p>
            Meaning perfect condition, no bumps, scratches or marks. Usually
            only the box has been opened, or the item&apos;s been repackaged.
          </p>
        </div>
      </SEOFriendlyDrawer>
    </>
  );
}
